import type { ElementInsertionPresetProvider } from '../../elements/types';
import { attributeInsertionPresetProvider } from './attributes/insertionPresets';
import { systemAssetsInsertionPresetProvider } from './systemAssets/insertionPresets';

// Order decides preset order in the modal: customer content first, system last.
export const elementInsertionPresetProviders = [
    attributeInsertionPresetProvider,
    systemAssetsInsertionPresetProvider,
] as const satisfies readonly ElementInsertionPresetProvider[];
